var confluenceInlineComment = {
    inclusive: false,
    excludes: '',
    attrs: {
        reference: {
            default: '',
        },
    },
    parseDOM: [{ tag: 'span[data-mark-type="confluenceInlineComment"]' }],
    toDOM: function (node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference,
            },
        ];
    },
};

export { confluenceInlineComment };



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/node_modules/@atlaskit/adf-schema/dist/esm/schema/marks/confluence-inline-comment.js